module.exports = __webpack_public_path__ + "img/g1.8344f4e5.png";